var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-subtitle',{class:_vm.appointmentColor + '--text'},[_c('v-icon',{staticClass:"mr-2",attrs:{"size":"16","color":_vm.appointmentColor}},[_vm._v("mdi-calendar")]),_vm._v(" "+_vm._s(_vm.startTime)+" - "+_vm._s(_vm.endTime)+", "+_vm._s(_vm.date)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }